/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: OriginFieldsView.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/18 @ 1749
 * ---
 * Description:
 */

import { observer }              from 'mobx-react';
import { Editor }                from '../../../store/observables/Editor';
import { IDataRef }              from '@revodigital/mpes';
import { useCallback, useState } from 'react';
import {
  LinkDynamicDialog
}                                from '../dialogs/data-origin/LinkDynamicDialog';
import { BuiltinFieldsSection }  from './BuiltinFieldsSection';
import { DynamicSection }        from './DynamicSection';

interface Props {
  editor: Editor;
}

export const OriginFieldsView = observer((props: Props) => {
  const [connectVisible, setConnectVisible] = useState(false);

  const handleAddNewOrigin = useCallback((data: IDataRef) => {
    props.editor.dataOriginFeature.addDataRef(data);
  }, [props.editor.dataOriginFeature.addDataRef]);

  return (
    <div>
      <div className="bp4-text-muted">Campi origini collegati</div>
      <BuiltinFieldsSection editor={ props.editor }/>
      <DynamicSection editor={ props.editor }
                      onLinkField={ () => setConnectVisible(true) }/>
      {
        connectVisible &&
        <LinkDynamicDialog editor={ props.editor } isOpen={ connectVisible }
                           onClose={ () => setConnectVisible(false) }
                           onLink={ handleAddNewOrigin }
        />
      }
    </div>
  );
});
